export const REFERRAL_QUERY_KEY = 'refid';
export const REFERRAL_COOKIE_KEY = 'referral-address';
export const REFERRAL_BONUS_POINTS = 15;
